import React from 'react';

import DetailsCard from 'bundles/apex/card/details';
import Text from 'bundles/apex/deals/show/listing/values/value';

const ListingCard = () => {
  return (
    <DetailsCard label="Lease Listing">
      <Text name="spaceType" />
      <Text name="closeDate" />
      <Text label="Space Name" name="address2" />
      <Text name="leaseRate" />
      <Text label="Space Size" name="spaceSizeLabel" />
      <Text name="leaseType" />
    </DetailsCard>
  );
};

export default ListingCard;
